import axios from 'axios'
import urls from '../../urls'

export default {
  state: {
    menuList: [],
    getMenuListError: null,
    loading: false
  },
  mutations: {
    GET_MENU_LIST_SUCCESS(state, payload) {
      state.menuList = payload
      state.getMenuListError = null
    },
    GET_MENU_LIST_ERROR(state, error) {
      state.getMenuListError = error
    },
    GET_MENU_LIST_LOADING(state, payload) {
      state.loading = payload
    }
  },
  actions: {
    GET_MENU_LIST({ commit }) {
      commit('GET_MENU_LIST_LOADING', true)
      return axios({
        method: 'GET',
        url: urls.GET_MENU_LIST_URL
      })
        .then(response => {
          commit('GET_MENU_LIST_SUCCESS', response.data)
          commit('GET_MENU_LIST_LOADING', false)
        })
        .catch(error => {
          commit('GET_MENU_LIST_ERROR', error)
          commit('GET_MENU_LIST_LOADING', false)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/main/main.js